import { Building2, Code2, FileCode2, Hash, Info } from 'lucide-react';
import {
  AvisosDeAjustes,
  BannerDeActivacion,
  BarraDeGuardado,
  Campo,
  CargandoAjustes,
  FalloDeAjustes,
  Resumen,
  Seccion,
  entrada,
  useAjustes,
} from './ajustes';

export function PaginaComprobantes() {
  const ajustes = useAjustes(['comprobante']);

  if (ajustes.cargando) {
    return <CargandoAjustes bloques={2} />;
  }
  if (ajustes.fallo) {
    return <FalloDeAjustes causa={ajustes.fallo} />;
  }

  const incluir = ajustes.booleano('comprobante_sistema_incluir');
  const ruc = ajustes.texto('comprobante_sistema_ruc');
  const proveedor = ajustes.texto('comprobante_sistema_proveedor');

  const incompleto = incluir && (ruc.trim() === '' || proveedor.trim() === '');

  return (
    <div className="grid gap-6">
      <AvisosDeAjustes ajustes={ajustes} />

      <BannerDeActivacion
        icono={FileCode2}
        activo={incluir}
        titulo={
          incluir
            ? 'Los comprobantes identifican al proveedor del sistema'
            : 'Los comprobantes no llevan los datos del proveedor'
        }
        descripcion={
          incluir
            ? 'Los dos campos viajan en la información adicional del XML'
            : 'Actívelo si la normativa vigente lo exige'
        }
        alCambiar={() => ajustes.alternar('comprobante_sistema_incluir', incluir)}
      />

      {incompleto && (
        <div
          role="alert"
          className="flex gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4"
        >
          <Info className="mt-0.5 size-4 shrink-0 text-amber-600" aria-hidden />
          <p className="text-xs uppercase text-amber-900">
            <span className="font-semibold">Falta un dato.</span> Está activado, pero el RUC o el
            nombre del proveedor están vacíos. Los comprobantes saldrían con los campos en blanco
            y el SRI los rechazaría.
          </p>
        </div>
      )}

      <Seccion icono={Code2} color="indigo" titulo="Proveedor del sistema informático">
        <div className="grid gap-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <Campo
              etiqueta="RUC del proveedor"
              icono={Hash}
              ayuda="Trece dígitos. Sale en el comprobante como «RUC Sistema Informático»"
            >
              <input
                value={ruc}
                onChange={(e) => ajustes.editar('comprobante_sistema_ruc', e.target.value)}
                placeholder="1792972302001"
                maxLength={13}
                className={`${entrada} importe pl-10`}
              />
            </Campo>

            <Campo
              etiqueta="Razón social del proveedor"
              icono={Building2}
              ayuda="Sale como «Proveedor Sistema Informático»"
            >
              <input
                value={proveedor}
                onChange={(e) => ajustes.editar('comprobante_sistema_proveedor', e.target.value)}
                placeholder="YUPAK ASOCIADOS CIA. LTDA"
                className={`${entrada} pl-10`}
              />
            </Campo>
          </div>

          <div className="rounded-xl border border-armazon-200 bg-armazon-50 p-4">
            <p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-armazon-500">
              Así saldrá en el XML
            </p>
            <pre className="importe overflow-x-auto text-[11px] leading-relaxed text-armazon-700">
              {[
                '<infoAdicional>',
                `  <campoAdicional nombre="RUC Sistema Informático">${ruc || '…'}</campoAdicional>`,
                `  <campoAdicional nombre="Proveedor Sistema Informático">${
                  proveedor || '…'
                }</campoAdicional>`,
                '</infoAdicional>',
              ].join('\n')}
            </pre>
          </div>
        </div>
      </Seccion>

      <Resumen
        puntos={[
          {
            etiqueta: 'En el comprobante',
            valor: incluir ? 'Sí se incluye' : 'No se incluye',
            listo: true,
          },
          { etiqueta: 'RUC', valor: ruc || 'Sin configurar', listo: ruc.trim() !== '' },
          {
            etiqueta: 'Proveedor',
            valor: proveedor || 'Sin configurar',
            listo: proveedor.trim() !== '',
          },
        ]}
      />

      <BarraDeGuardado ajustes={ajustes} />
    </div>
  );
}
